// extracted by mini-css-extract-plugin
export default {"markAsFailedButton":"HistoryDetailsModal-markAsFailedButton-P9sG9 Button-button-paJ9a Link-link-RInnp"};